
































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import {BankAccountOperations} from '@/enums/BankAccountOperations';
import BankAccountsApi from '@/apis/BankAccountsApi';
import ProductsApi from '@/apis/ProductsApi';
import ProductResponseModel from '@/models/products/ProductResponseModel';
import BankAccountPurchaseTransactionsRequestModel from '@/models/bankaccounts/BankAccountPurchaseTransactionsRequestModel';

declare var Stripe: any;
const stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLISH_KEY);
const elements = stripe.elements();
const card = elements.create('card');

@Component({
        name: 'BankAccountPurchaseTransactions',
    },
)
export default class BankAccountPurchaseTransactions extends ViewBase {
    @Prop({default: 0, required: true})
    public bankAccountId!: number;

    public product?: ProductResponseModel;
    public authorized: boolean = false;

    public quantity: number = 0;
    public cardError: string = '';
    public cardComplete: boolean = false;

    public get showProduct(): boolean {
        if ( !this.initializing && !this.initializationError ) {
            return true;
        }

        return false;
    }

    public get total(): number {
        if ( this.product ) {
            return this.quantity * this.product.price;
        }

        return 0;
    }

    public addQuantity() {
        this.quantity = this.quantity + 1;
    }

    public subtractQuantity() {
        if ( this.quantity > 0 ) {
            this.quantity = this.quantity - 1;
        }
    }

    public get disablePurchaseButton(): boolean {
        if ( this.quantity === 0 ) {
            return true;
        }

        if ( !this.cardComplete ) {
            return true;
        }

        return false;
    }

    public async purchaseClick() {

        if ( this.isFormValid() ) {
            try {
                this.resetProcessingValues();

                const {token, error} = await stripe.createToken(card);

                if ( error ) {
                    this.cardError = error.message;
                }
                else {
                    const request = new BankAccountPurchaseTransactionsRequestModel();
                    request.quantity = this.quantity;
                    request.paymentToken = token.id;

                    const api = new BankAccountsApi();
                    const response = await api.purchaseTransactionsAsync(this.bankAccountId, this.$store.state.member.jwt, request);

                    this.$store.commit('mutateSnackbarText', 'Thank you for your purchase.');
                    this.$store.commit('mutateShowSnackbar', true);

                    await this.$router.push({name: 'bankaccountdashboard', params: { bankAccountId: this.bankAccountId.toString(10)}});
                }
            }
            catch ( err ) {
                await this.handleProcessingErrorAsync(err);
            }
            finally {
                this.processing = false;
            }
        }
    }

    public async created() {
        if ( this.$store.state.selectedBankAccount.authorizedOperations & BankAccountOperations.PURCHASE_TRANSACTIONS )
        {
            this.authorized = true;

            try {
                this.resetInitializationValues();

                const api = new ProductsApi();
                this.product = await api.getProductAsync(3);
            }
            catch ( err ) {
                await this.handleInitializationErrorAsync(err);
            }
            finally {
                this.initializing = false;
            }

            if ( this.showProduct ) {

                this.$nextTick(() => {
                    card.mount('#card-element');
                    card.addEventListener('change', (e: any) => {
                        if (e.error) {
                            this.cardError = e.error.message;
                        }
                        else {
                            this.cardError = '';
                        }
                        this.cardComplete = e.complete;
                    });
                });
            }

        }
    }

    private isFormValid(): boolean {
        const form: any = this.$refs.purchaseTransactionsForm;

        return form.validate();
    }

}

